import React from 'react';
import { BaseTimelineItem } from './BaseTimelineItem';
import type { BaseTimelineEvent } from './types';
import { SectionCard } from '../../sections/SectionCard';

export interface TimelineSectionProps {
  events: BaseTimelineEvent[];
  isExpanded?: boolean;
  onToggle?: () => void;
  className?: string;
  isDetailView?: boolean;
  title?: string;
}

export const TimelineSection = React.memo<TimelineSectionProps>(({
  events,
  isExpanded = false,
  onToggle,
  className = '',
  isDetailView = false,
  title = 'Timeline',
}) => {
  if (!events || events.length === 0) {
    return null;
  }

  const visibleEvents = isDetailView || isExpanded ? events : [events[0]];

  const timelineContent = (
    <div className="w-full flex flex-col">
      {visibleEvents.map((event, index) => {
        const isLast = index === visibleEvents.length - 1;
        return (
          <BaseTimelineItem
            key={event.id || index}
            event={event}
            isLast={isLast}
            showLine={!isLast}
          />
        );
      })}
    </div>
  );

  return (
    <SectionCard
      title={title}
      layout={isDetailView ? 'two-column' : 'down'}
      isCollapsible={Boolean(onToggle) && !isDetailView}
      isCollapsed={!isExpanded}
      onTitleClick={onToggle}
      className={className}
    >
      {timelineContent}
    </SectionCard>
  );
});

TimelineSection.displayName = 'TimelineSection';
